import styled from 'styled-components'

import { IconInfo } from '@avantstay/backoffice-vectors'

import { _L_Medium, _M_Normal, mainColors } from '../../styles'
import { Button } from '../Button'

export const Root = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80%;
  padding-bottom: 24px;

  > svg {
    flex-shrink: 0;
  }
`

export const Title = styled.div`
  display: flex;
  color: ${mainColors.primaryMedium};
  ${_L_Medium};
`

export const Subtitle = styled.div`
  display: flex;
  color: ${mainColors.neutralExtremelyDark};
  ${_M_Normal};
`

export const ResetButton = styled(Button.Primary)`
  width: 200px;
`

export const InfoIcon = styled(IconInfo)`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background: ${mainColors.neutralLight};
  width: 44px;
  height: 44px;
`
